import addproduct from 'Backend/Firestore/upload'
import upload2 from 'Backend/Storage/upload2'
import errormessage from 'components/Main/error'
import validateproduct from 'Backend/Firestore/validate'
import React from 'react'
import Swal from 'sweetalert2'

export default function HDD() {
    const css = `
  .form-control{
        width: 99%;
    }
    body{
        overflow-x: hidden;
    }
    input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
  `
  function Back() {
    Swal.fire({
      title: 'Are you sure?',
      text: "Are you sure that you want to go back?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, go back!'
    }).then((result) => {
      if (result.isConfirmed) {
        history.back()
      }
    })
  }
    function Add(){
        if(document.getElementById("Model_Name").value === ""){
          errormessage("Please Enter Model Name")
        }else if(document.getElementById("Model_Price").value === ""){
        errormessage("Please Enter Model Price")
        }else if(document.getElementById("HDD_Picture").value === ""){
          errormessage("Please Upload Picture")
        }else{
          validateproduct('HDD',document.getElementById("Model_Name").value,()=>{
            upload2("HDD",document.getElementById("Model_Name").value,document.getElementById("HDD_Picture").files[0],(url)=>{
              addproduct(document.getElementById('Available').value,"HDD",{
                  Model_Name:document.getElementById("Model_Name").value,
                  Model_Price:document.getElementById("Model_Price").value,
                  Company:document.getElementById("Company").value,
                  Terabyte:document.getElementById("Terabyte").value,
                  Image:url
              });
          })
          })
      }
    }
  return (
    <>
    <style>{css}</style>
      <center><h1>Add Hard Disk</h1></center>
      <div className="row" style={{width:'80%',marginLeft: '10%'}}>
        <div className="col-sm-12">
        <label htmlFor="Model_Name" className="form-label" style={{fontWeight: "bold"}}>Model Name</label>
                <input type="text" id="Model_Name" data-name="Model_Name" required className="form-control"/>
                <label htmlFor="Model_Price" className="form-label" style={{fontWeight: "bold"}}>Model Price</label>
                <input type="number" id="Model_Price" data-name="Model_Price" required className="form-control"/>
                <label htmlFor="Company" className="form-label" style={{fontWeight: "bold"}}>Company</label>
                <select data-name="Company" id="Company" className="form-control">
                    <option defaultValue="HIKVISION">HIKVISION</option>
                    <option defaultValue="CPPLUS">CPPLUS</option>
                    <option defaultValue="PRAMA">PRAMA</option>
                </select>
                <label htmlFor="Terabyte" className="form-label" style={{fontWeight: "bold"}}>Terabyte</label>
                <select data-name="Terabyte" id="Terabyte" className="form-control">
                    <option defaultValue="1TB">1TB</option>
                    <option defaultValue="2TB">2TB</option>
                    <option defaultValue="4TB">4TB</option>
                    <option defaultValue="6TB">6TB</option>
                    <option defaultValue="8TB">8TB</option>
                    <option defaultValue="10TB">10TB</option>
                    <option defaultValue="20TB">20TB</option>
                </select>
                <label htmlFor="Available" className="form-label" style={{fontWeight: "bold"}}>Available</label>
                    <select id="Available" className="form-control">
                        <option defaultValue="Yes">Yes</option>
                        <option defaultValue="No">No</option>
                    </select>
                <label htmlFor="HDD_Picture" className="form-label" style={{fontWeight: "bold"}}>HDD Picture</label>
                <input type="file" id="HDD_Picture" data-name="HDD_Picture" accept="image/*" className="form-control"/>
                <br/>
                <div className='row'>
                <div className='col-sm-12' style={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                <button className="btn btn-primary" type="button" style={{marginRight: '10px'}} onClick={()=>{Add()}}>Save</button>
                <button className="btn btn-danger" type="button" onClick={()=>{Back()}}>Back to Products</button>
                </div>
                </div>
        </div>
      </div>
    </>
  )
}
